// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"18d7acf7","88":"56b41066","655":"abd617ee"}[chunkId] + ".chunk.css";
};